import DOMPurify from "dompurify"

// AA house style: no double quotes. Convert straight " to curly singles,
// choosing opening ‘ or closing ’ from the preceding character.
const toCurlySingles = (text: string) =>
  text.replace(/"/g, (_match, offset: number, str: string) => {
    const prev = str[offset - 1]
    const isOpening = !prev || /[\s(\[{‘“]/.test(prev)
    return isOpening ? "‘" : "’"
  })

// Apply a text transform to everything outside HTML tags, leaving tag
// markup (and its attribute quotes) untouched.
const transformText = (html: string, fn: (text: string) => string) =>
  html.replace(/<[^>]*>|[^<]+/g, segment =>
    segment.startsWith("<") ? segment : fn(segment),
  )

export const cleanHTML = (
  html: string,
  tags = ["b", "strong", "i", "em", "p", "a", "ul", "ol", "li", "br", "sup"],
) => {
  const sanitised = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: tags,
  }).replace(/&nbsp;/g, " ")

  return transformText(sanitised, toCurlySingles)
}
